
import React from 'react';
import { Star } from 'lucide-react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { 
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/components/ui/carousel';

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Mother of three",
    quote: "After a small fire in our neighborhood, I realized how unprepared we were. EmergencyPlan helped me create a comprehensive plan for my family in just 15 minutes. Now I sleep better at night.",
    avatar: "/lovable-uploads/b8d39d0e-5a80-4adf-8db5-cf431ed387ad.png",
    rating: 5
  },
  {
    name: "Michael Chen",
    role: "Small business owner",
    quote: "As a business owner, I needed to ensure the safety of both my employees and customers. The personalized recommendations were incredibly helpful and specific to my situation.",
    avatar: "/lovable-uploads/9359bcc3-3fe4-4dd3-99e8-52cacd64cf29.png",
    rating: 5
  },
  {
    name: "Elena Rodriguez",
    role: "Healthcare worker",
    quote: "I've seen firsthand what happens when people aren't prepared for emergencies. This platform guided me through creating plans for various scenarios I hadn't even considered.",
    avatar: "/lovable-uploads/11073594-1efa-4e27-9be1-438018b6bcaf.png",
    rating: 5
  },
  {
    name: "Thomas Wright",
    role: "Retiree",
    quote: "Living in a flood-prone area, I always worried about what would happen during an emergency. Now I have clear steps to follow and even my grandchildren know what to do.",
    avatar: "/lovable-uploads/f021dfd5-d05b-4467-b534-a925be73166f.png",
    rating: 5
  }
];

export const TestimonialsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4 text-emergency-700">What Our Users Say</h2>
          <p className="text-lg text-muted-foreground">
            Real stories from people who've prepared for the unexpected
          </p>
        </div>

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="max-w-5xl mx-auto"
        >
          <CarouselContent>
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3 pl-4">
                <div className="bg-emergency-50 p-6 rounded-xl border border-emergency-100 h-full flex flex-col">
                  <div className="flex items-center mb-4">
                    <div className="w-16 h-16 rounded-full overflow-hidden mr-4 border-2 border-emergency-200">
                      <AspectRatio ratio={1 / 1}>
                        <img 
                          src={testimonial.avatar} 
                          alt={testimonial.name} 
                          className="object-cover w-full h-full"
                        />
                      </AspectRatio>
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg">{testimonial.name}</h4>
                      <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                    </div>
                  </div>
                  
                  <div className="flex mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={16} className="fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  
                  <blockquote className="text-muted-foreground italic flex-grow">
                    "{testimonial.quote}"
                  </blockquote>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center mt-8">
            <CarouselPrevious className="relative static -left-0 translate-y-0 mr-2" />
            <CarouselNext className="relative static -right-0 translate-y-0 ml-2" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
